import AIDataServices from "components/ai-data-services/AIDataServices";

export default function AIDataServicesPage() {
  return <AIDataServices />;
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "AI Data Services",
        description:
          "Turn your scattered business data into answers you can act on. We connect your existing sources to a working AI interface in 10 days.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "/solutions/ai-data-services",
      },
    },
  };
}
